import css from "classnames";
import React from "react";
import Development from "components/development";
import styles from "./boundary.module.css";

interface Props {
  message?: string;
}

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  state = { error: null } as State;

  static getDerivedStateFromError (error: Error): { error: Error; } {
    return { error };
  }

  render (): React.ReactNode {
    const { error } = this.state;
    if (error === null) {
      return this.props.children;
    }

    const { message = "An unexpected error was encountered." } = this.props;
    return (
      <div className={css("bg-danger", styles.boundary)}>
        <div>{message}</div>
        <Development>
          <div>{JSON.stringify(error)}</div>
        </Development>
      </div>
    );
  }
}
